import { useSelector } from "react-redux";
import MicButton from "./MicButton";
import SpeakingWave from "./SpeakingWave";
import ThinkingBubble from "./ThinkingBubble";
import useVoiceActions from "./useVoiceAction";
import React from "react";
import PropTypes from "prop-types";

const MainContent = React.memo(function MainContent({
  isClosedRef,
  handleChatResponse,
  voiceOpen,
  voiceOpenRef,
  synthesizer,
  audioStop,
  player,
  recognizer,
  isMicOnRef,
}) {
  const isMicOn = useSelector((state) => state.voiceMode.isMicOn);
  const { mode, startListening, stopListening } = useVoiceActions(
   { isClosedRef,
    handleChatResponse,
    voiceOpenRef,
    synthesizer,
    audioStop,
    player,
    recognizer,
    isMicOnRef}
  );

  return (
    <div className="flex flex-col items-center justify-center w-full h-full">
      {mode === "idle" && (
        <MicButton active={isMicOn} onClick={startListening} />
      )}
      {mode === "listening" && (
        <MicButton active={isMicOn} onClick={stopListening} />
      )}
      {mode === "thinking" && <ThinkingBubble />}
      {mode === "speaking" && <SpeakingWave />}
    </div>
  );
});

MainContent.propTypes = {
  isClosedRef: PropTypes.object,
  handleChatResponse: PropTypes.func,
  voiceOpen: PropTypes.bool,
  voiceOpenRef: PropTypes.object,
  synthesizer: PropTypes.any,
  audioStop: PropTypes.any,
  player: PropTypes.any,
  recognizer: PropTypes.any,
  isMicOnRef: PropTypes.object,
};

export default MainContent;
